import Repository from '@/libs/axios'

const autoOrderCancelSettingsResource = '/admin/settings/order-cancel'

export default {
  getOrderCancelSetting() {
    return Repository.get(`${autoOrderCancelSettingsResource}`)
  },
  updateOrderCancelSetting(payload) {
    return Repository.put(`${autoOrderCancelSettingsResource}`, payload)
  },
}
